/* Number of questions in verbal testlet*/
export const QUESTIONS_IN_TESTLET = 4;
